import { FC, SVGProps } from 'react'

export const Power: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.4334 2.75C12.4334 2.33579 12.0976 2 11.6834 2C11.2692 2 10.9334 2.33579 10.9334 2.75V11.7489C10.9334 12.1631 11.2692 12.4989 11.6834 12.4989C12.0976 12.4989 12.4334 12.1631 12.4334 11.7489V2.75ZM6.48972 7.45662C6.78302 7.16414 6.7837 6.68927 6.49122 6.39596C6.19875 6.10265 5.72387 6.10198 5.43056 6.39445C1.96877 9.84641 1.96986 15.4506 5.42006 18.9107L5.42157 18.9122C8.88189 22.3627 14.476 22.3627 17.9363 18.9122L17.9378 18.9107C21.3883 15.4504 21.3883 9.85628 17.9378 6.39596C17.6453 6.10265 17.1704 6.10198 16.8771 6.39445C16.5838 6.68693 16.5831 7.1618 16.8756 7.45511C19.7421 10.3297 19.7423 14.9758 16.8764 17.8508C14.0017 20.7165 9.35616 20.7165 6.48147 17.8508C3.61522 14.9755 3.61656 10.3216 6.48972 7.45662Z"
			fill="currentColor"
		/>
	</svg>
)
